import {useQuery} from '@tanstack/react-query'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

export const GetSitePrefrences = () => {
    const {app} = getConfig()
    const appOrigin = useAppOrigin()
    const {organizationId, siteId} = app.commerceAPI.parameters

    const fetchPreferences = async () => {
        const url = `${appOrigin}/preferences`
        return await fetch(url, {
            method: 'GET'
        })
            .then((res) => res.json())
            .then((json) => {
                return json
            })
    }

    const {data: preferences} = useQuery({
        queryKey: ['site-preferences', organizationId, siteId],
        queryFn: fetchPreferences,
        staleTime: 5 * 60000, // 5min
        cacheTime: 28 * 60000, // 28min,
        enabled: typeof window !== 'undefined'
    })

    const getcustomPreferencevalue = (id) => {
        if (!preferences) {
            return
        }
        const list = preferences?.data || []
        const preference = list.find((pref) => pref.id === id)
        return preference ? preference.value : null
    }

    return {getcustomPreferencevalue}
}
